import React, { useState, useContext } from 'react';
import { PostData } from './Fetch';
import { TranslationContext, SettingsContext } from "./Context";

function ContactUsRequest(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [customerNumber, setCustomerNumber] = useState('');
    const [email, setEmail] = useState('');
    const [consent, setConsent] = useState(false);
    const [model] = useState(props.vehicle.modelName);
    const [manufacturer] = useState(props.vehicle.manufacturerName);
    const [type] = useState(props.vehicle.typeName);
    const [power] = useState(props.vehicle.powerKwFrom);
    const [comments, setComments] = useState('');

    function handleSubmit(e) {
        e.preventDefault();
        const data = {
            name: name,
            address: address,
            customerNumber: customerNumber,
            email: email,
            manufacturer: manufacturer,
            model: model,
            type: type,
            power: power,
            comments: comments,
            consent: consent
        };

        const headers = {
            'X-sc-contextitemid': settings.contextitemid,
            'X-sc-datasourceitemid': settings.datasourceitemid,
            'X-sc-language': settings.language,
            'X-sc-market': settings.market,
            'Content-Type': 'application/json'
        };

        PostData('/order/contactUs', data, headers)
            .then(data => {
                props.onSent(e);
            });
    }

    return (
        <div className="container u-mtop50 u-mbottom50">
            <div className="row">
                <div className="col-xs-12">
                    <h2 className="u-textBold38 text-center u-mbottom30">{translation["TecAlliencePartSearch.ContactUs.RequestInformation"]}</h2>
                </div>
            </div>

            <div className="row">
                <form onSubmit={handleSubmit}>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Manufacturer"]}</label>
                            <input className="form-control input-lg disabled" type="text" value={manufacturer}  disabled required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Model"]}</label>
                            <input className="form-control input-lg disabled" type="text" value={model} disabled required />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Type"]}</label>
                            <input className="form-control input-lg disabled" type="text" value={type} disabled required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Power"]}</label>
                            <input className="form-control input-lg disabled" type="text" value={power} disabled required />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Name"]} *</label>
                            <input className="form-control input-lg" type="text" required onChange={e => setName(e.target.value)} value={name} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.CustomerNumber"]} *</label>
                            <input className="form-control input-lg" type="text" required onChange={e => setCustomerNumber(e.target.value)} value={customerNumber} />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Address"]} *</label>
                            <input className="form-control input-lg" type="text" required onChange={e => setAddress(e.target.value)} value={address} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Email"]} *</label>
                            <input className="form-control input-lg" type="email" required onChange={e => setEmail(e.target.value)} value={email} />
                        </div>
                    </div>

                    <div className="col-xs-12">
                        <div className="form-group">
                            <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.ContactUs.Comments"]}</label>
                            <textarea className="form-control input-lg" id="comments" rows="5" onChange={e => setComments(e.target.value)} value={comments}></textarea>
                        </div>
                    </div>

                    <div className="col-xs-12"><div className="small text-muted u-mbottom20">{translation["TecAlliencePartSearch.ContactUs.ExtraInformation"]}</div>

                        <div className="custom-form">
                            <div className="custom-form-cbxWrap">
                                <input className="custom-form-checkbox" type="checkbox" required="required" id="{1B57487A-BFFF-4D49-9520-41A64792F735}" name="{1B57487A-BFFF-4D49-9520-41A64792F735}" onChange={e => setConsent(e.target.checked)} checked={consent} />
                                <label className="custom-form-checkboxLabel u-textRegular16" for="{1B57487A-BFFF-4D49-9520-41A64792F735}">{translation["TecAlliencePartSearch.ContactUs.IAgreeToTheTermsAndConditions"]}</label>
                            </div>
                        </div>

                        <div className="text-center">
                            <button className="btn btn-primary u-xsBlock">{translation["TecAlliencePartSearch.ContactUs.SendContactRequest"]}</button>
                        </div>
                    </div>

                </form>

            </div>
        </div>);

}

export default ContactUsRequest;